import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { mapSlides } from '../data/content';
export function MapCarousel() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const slide = mapSlides[index];
  const go = (step: number) => {
    setDirection(step);
    setIndex(current => (current + step + mapSlides.length) % mapSlides.length);
  };
  return <div className="rounded-2xl border border-night-line bg-night-panel p-3 sm:p-5" role="group" aria-roledescription="carrusel" aria-label="Ejemplos de mapas mentales" data-id="element-109" data-mp="3hylc74qi1brq">
      <div className="relative overflow-hidden rounded-xl bg-parchment" data-id="element-110" data-mp="3dyuhwr1rkdig">
        <div className="aspect-[3/2] w-full" data-id="element-111" data-mp="38z83iea78r82">
          <AnimatePresence initial={false} mode="wait" data-id="element-112" data-mp="1c53jhxkrl1gy">
            <motion.img key={slide.image} src={slide.image} alt={`Mapa mental del libro de ${slide.book}`} initial={{
            opacity: 0,
            x: direction * 24
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: direction * -24
          }} transition={{
            duration: 0.25,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full w-full object-contain" data-id="element-113" data-mp="1c4lpz8phl1cq" />
          </AnimatePresence>
        </div>

        <button type="button" onClick={() => go(-1)} aria-label="Mapa anterior" className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-night/85 p-2.5 text-parchment transition-colors duration-150 ease-out hover:bg-night focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft sm:left-3" data-id="element-114" data-mp="2b4pp2yhn7z6l">
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-115" data-mp="2u2s9ezz8x7y2" />
        </button>
        <button type="button" onClick={() => go(1)} aria-label="Mapa siguiente" className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-night/85 p-2.5 text-parchment transition-colors duration-150 ease-out hover:bg-night focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft sm:right-3" data-id="element-116" data-mp="3ht5zwm26myqj">
          <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-117" data-mp="3rh9wuhtpmg5b" />
        </button>
      </div>

      <div className="mt-4 flex flex-col items-center gap-3 px-1 sm:flex-row sm:justify-between" data-id="element-118" data-mp="3mfkk8xqu9uf4">
        <div aria-live="polite" className="text-center sm:text-left" data-id="element-119" data-mp="3hi2l1z2mitkb">
          <p className="font-display text-lg font-semibold text-parchment" data-id="element-120" data-mp="3dhsfgniqu55z">
            {slide.book}
          </p>
          <p className="font-sans text-sm text-parchment/55" data-id="element-121" data-mp="38p8tp39wk3q3">{slide.block}</p>
        </div>

        <div className="flex items-center gap-2" data-id="element-122" data-mp="33rpdvyxk3iw1">
          {mapSlides.map((item, slideIndex) => <button key={item.book} type="button" onClick={() => {
          setDirection(slideIndex > index ? 1 : -1);
          setIndex(slideIndex);
        }} aria-label={`Ver el mapa de ${item.book}`} aria-current={slideIndex === index} className={`h-2.5 rounded-full transition-[width,background-color] duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft ${slideIndex === index ? 'w-7 bg-gold-soft' : 'w-2.5 bg-night-line'}`} data-id="element-123" data-mp="2ysvyg0yplht8" data-mpi={slideIndex} />)}
        </div>
      </div>

      
    </div>;
}